/** Four-direction grid vocabulary shared by every tile game (Ice, the dungeon). */
export type Dir = 'up' | 'down' | 'left' | 'right'
export const DIRS: readonly Dir[] = ['up', 'down', 'left', 'right']

export interface Pos {
  r: number
  c: number
}

export const DELTA: Record<Dir, Pos> = {
  up: { r: -1, c: 0 },
  down: { r: 1, c: 0 },
  left: { r: 0, c: -1 },
  right: { r: 0, c: 1 },
}

export function samePos(a: Pos, b: Pos): boolean {
  return a.r === b.r && a.c === b.c
}
